<template>
  <div class="energyData">
    <div class="bg">
      <dv-loading v-if="loading">Loading...</dv-loading>
      <div v-else class="host-body">
        <!-- <div class="d-flex jc-center">
			  <dv-decoration-10 class="dv-dec-10" />
			  <div class="d-flex jc-center">
				<dv-decoration-8 class="dv-dec-8" :color="decorationColor" />
				<div class="title">
				  <span class="title-text">访客数据分析</span>
				</div>
				<dv-decoration-8 class="dv-dec-8" :reverse="true" :color="decorationColor" />
			  </div>
			  <dv-decoration-10 class="dv-dec-10-s" />
			</div> -->

        <dv-border-box-1
          style="width: 100%; height: auto"
          :color="['#0099FE', '#0099FE']"
        >
          <div style="padding: 20px 30px">
            <div style="display: flex; align-items: center; margin-left: 10px">
              <el-select
                v-model="xtype"
                size="mini"
                style="width: 70px; margin-right: 10px"
                @change="changeSeach1()"
              >
                <el-option label="天" value=""></el-option>
                <el-option label="月" value="month"></el-option>
                <el-option label="年" value="年"></el-option>
              </el-select>

              <el-date-picker
                v-show="xtype == ''"
                v-model="value2"
                size="mini"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                align="right"
                :editable="false"
              >
              </el-date-picker>

              <el-date-picker
                v-show="xtype == 'month'"
                v-model="value5"
                type="monthrange"
                range-separator="至"
                start-placeholder="开始月份"
                end-placeholder="结束月份"
                size="mini"
                :editable="false"
              >
              </el-date-picker>

              <div v-show="xtype == 'year'">
                <el-date-picker
                  type="year"
                  v-model="value6"
                  placeholder="选择年"
                  size="mini"
                  :editable="false"
                >
                </el-date-picker>
                <span>至</span>
                <el-date-picker
                  type="year"
                  v-model="value7"
                  placeholder="选择年"
                  size="mini"
                  :editable="false"
                >
                </el-date-picker>
              </div>
            </div>
            <div class="line1">
              <div class="line1-item" ref="line">
                <dv-border-box-13 :style="'width:100%;padding:10px;height:100%;'">
                  <div style="margin-top: 10px; display: flex">
                    <!-- <div style="margin-left: 10px; text-align: left">波峰波谷图</div> -->
                  </div>

                  <div class="leftEcharts" ref="leftEcharts"></div>
                </dv-border-box-13>
              </div>

              <dv-border-box-12 style="flex: 1; padding: 10px">
                <div style="margin-top: 10px; display: flex">
                  <!-- <div style="margin-left: 20px; text-align: left">区域能耗</div> -->
                  <div
                    style="
                      margin-right: 10px;
                      display: flex;
                      align-items: center;
                      margin-left: 50px;
                    "
                  ></div>
                </div>
                <div class="leftEcharts2" ref="leftEcharts2"></div>
              </dv-border-box-12>
            </div>

            <div class="line2">
              <div class="line2-item">
                <dv-border-box-13 style="padding: 10px; height: 100%">
                  <div
                    style="
                      margin-top: 10px;
                      display: flex;
                      justify-content: space-between;
                    "
                  >
                    <!-- <div style="margin-left: 20px; text-align: left">商铺时段能耗</div> -->
                    <div
                      style="margin-right: 10px; display: flex; align-items: center"
                    ></div>
                  </div>
                  <div class="rightEcharts" ref="rightEcharts"></div>
                </dv-border-box-13>
              </div>
            </div>
          </div>
        </dv-border-box-1>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
import { formatTime1 } from "../../utils/index.js";
import ScaleBox from "vue2-scale-box";
var dayjs = require("dayjs");
export default {
  components: {
    ScaleBox,
  },
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      value2: "",
      value5: "",
      value6: "",
      value7: "",
      allSum: "",
      yearRatio: "",
      linkRatio: "",
      monSum: 0,
      monA: 0,
      monB: 0,
      monC: 0,
      yearSum: 0,
      yearA: 0,
      yearB: 0,
      yearC: 0,
      daySum: 0,
      dayA: 0,
      dayB: 0,
      dayC: 0,
      config: {},
      xtype: "",
      queryDate1: [],

      queryDate3: [],
      queryDate4: [],
      timing: null,
      loading: true,
      dateDay: null,
      dateYear: null,
      dateWeek: null,
      weekday: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
      decorationColor: ["#568aea", "#000000"],
      lineWidth: 0,
    };
  },
  created() {},
  mounted() {
    this.cancelLoading();
    setTimeout(() => {
      this.lineWidth = this.$refs.line.offsetWidth;
      this.changeSeach1();
      //   this.changeSeach2();
      //   this.setRightEcharts();
    }, 500);
    window.addEventListener("resize", () => this.Refresh());
    window.addEventListener("setItem", () => {});
  },
  beforeDestroy() {
    clearInterval(this.timing);
    // 销毁
    window.removeEventListener("resize");
  },
  methods: {
    changeSeach1() {
      this.$http
        .post(`/api/bdVisitApply/listParkingData`, {
          xtype: this.xtype,
          "xsize": "7",
        })
        .then((res) => {
          if (res.data.code == 0) {
            let xArr = [];
            let yArr = [];
            res.data.data.list.forEach((element) => {
              xArr.push(element.xValue);
              yArr.push(element.yValue);
            });
            this.setLeftEcharts(xArr, yArr);
            this.setRightEcharts(xArr, yArr);
            let arr = [];

            xArr.forEach((element, index) => {
              let data = {
                name: xArr[index],
                value: yArr[index],
              };
              arr.push(data);
            });
            this.setLeftEcharts2(arr);
          }
        });

      // let xArr = [];
      // let yArr = [];
      // if (this.xtype == "") {
      //   xArr = [
      //     "2024-06-18",
      //     "2024-06-19",
      //     "2024-06-20",
      //     "2024-06-21",
      //     "2024-06-22",
      //     "2024-06-23",
      //     "2024-06-24",
      //   ];
      //   yArr = [782, 832, 901, 934, 1320, 1283, 682];
      // }
      // if (this.xtype == "month") {
      //   xArr = [
      //     "2023-12",
      //     "2024-01",
      //     "2024-02",
      //     "2024-03",
      //     "2024-04",
      //     "2024-05",
      //     "2024-06",
      //   ];
      //   yArr = [121782, 121832, 119011, 119341, 111320, 111283, 121682];
      // }
      // if (this.xtype == "year") {
      //   xArr = ["2022", "2023", "2024"];
      //   yArr = [1113207, 1112830, 616829];
      // }
    },
    setLeftEcharts(xArr, yArr) {
      let option = {
        xAxis: {
          data: xArr,
          axisLabel: {
            rotate: 30, // X轴标签倾斜 45 度
          },
        },
        yAxis: {},
        series: [
          {
            type: "bar", //形状为柱状图
            data: yArr,
          },
        ],
      };
      this.$echarts.init(this.$refs.leftEcharts, "dark").setOption(option);
    },
    changeSeach2() {
      //   this.$http
      //     .post(`/api/energy/getRinglike`, {
      //       startTime: this.queryDate3[0],
      //       endTime: this.queryDate3[1],
      //     })
      //     .then((res) => {
      //       if (res.data.code == 0) {
      let arr = [];
      // res.data.data.forEach((element) => {
      //   let item = {
      //     name: element.type,
      //     value: element.sum || 0,
      //   };
      //   arr.push(item);
      // });
      this.setLeftEcharts2(arr);
      //   }
      // });
    },
    setRightEcharts(xArr, yArr) {
      //   this.$http.get(`/api/energy/timePeriodEnergyConsumption`).then((res) => {
      //     if (res.data.code == 0) {
      //   let xArr = [];
      //   let yArr = [];
      //   res.data.data.forEach((element) => {
      //     xArr.push(element.readingTime);
      //     yArr.push(element.positiveElec);
      //   });
      let option = {
        backgroundColor: "",
        tooltip: {
          trigger: "axis",
        },
        grid: {
          top: "30",
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          axisTick: {
            show: false, //轴线刻度
          },
          boundaryGap: false,
          data: xArr,
          axisLabel: {
            color: "#ffffff",
            interval: 0,
          },
          axisLine: {
            lineStyle: {
              color: "#ffffff", //x轴颜色
            },
          },
        },
        color: ["#277CD5"],
        yAxis: {
          type: "value",
          axisTick: {
            show: false, //轴线刻度
          },
          axisLabel: {
            color: "#ffffff",
            // formatter: "{value}kW·h",
          },
          axisLine: {
            lineStyle: {
              color: "#ffffff", //Y轴颜色
            },
          },
          splitLine: {
            lineStyle: {
              color: "#505687",
            },
          },
        },
        series: [
          {
            // name: "Highest",
            data: yArr,
            type: "line",
            symbolSize: 8,
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                {
                  offset: 0.1,
                  color: "#212a61",
                },
                {
                  offset: 1,
                  color: "#277CD5",
                },
              ]),
            },
            smooth: true,
            // markPoint: {
            //     data: [{ type: "max", name: "Max" }, { type: "min", name: "Min" }]
            // },
            // label: {  //显示值
            //     show: true,
            //     position: 'top'
            //   },
          },
        ],
      };
      this.$echarts.init(this.$refs.rightEcharts, "dark").setOption(option);
      //     }
      //   });
    },

    setLeftEcharts2(arr) {
      //   let arr = [
      //     {
      //       name: "111",
      //       value: 10,
      //     },
      //     {
      //       name: "222",
      //       value: 50,
      //     },
      //     {
      //       name: "333",
      //       value: 50,
      //     },
      //   ];
      let option = {
        grid: {
          top: "0",
          left: "10",
          right: "40",
          bottom: "0",
          containLabel: true,
        },
        title: {
          // text: '',
          subtext: "",
          left: "center",
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          top: "bottom",
        },
        series: [
          {
            name: "Access From",
            type: "pie",
            radius: ["30%", "60%"],
            data: arr,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "#ffffff",
              },
            },
          },
        ],
      };
      this.$echarts.init(this.$refs.leftEcharts2, "dark").setOption(option);
    },

    cancelLoading() {
      setTimeout(() => {
        this.loading = false;
      }, 500);
    },
    Refresh() {
      this.$router.go(0);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/_variables.scss";

.energyData {
  //     width: 100vw;
  //   height: 100vh;
  background-color: #091631;
  // overflow: hidden;
  color: #d3d6dd;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transform-origin: left top;
  overflow-x: hidden;
  overflow-y: auto;

  .bg {
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center center;
  }

  .host-body {
    padding: 10px 5px 0 5px;

    .dv-dec-10,
    .dv-dec-10-s {
      width: 33.3%;
      height: 5px;
    }

    .dv-dec-10-s {
      transform: rotateY(180deg);
    }

    .dv-dec-8 {
      width: 200px;
      height: 50px;
    }

    .title {
      position: relative;
      width: 500px;
      text-align: center;
      background-size: cover;
      background-repeat: no-repeat;

      .title-text {
        font-size: 28px;
        position: absolute;
        bottom: 0px;
        left: 50%;
        transform: translate(-50%);
        color: #ffffff;
      }

      .dv-dec-6 {
        position: absolute;
        bottom: 10px;
        left: 50%;
        width: 250px;
        height: 8px;
        transform: translate(-50%);
      }
    }

    .leftEcharts {
      height: 200px;
    }

    .leftEcharts2 {
      height: 220px;
    }

    .rightEcharts {
      height: 350px;
    }

    .rightEcharts3 {
      height: 210px;
      margin-left: 10px;
    }

    ::v-deep .el-progress__text {
      color: #ffffff !important;
    }

    ::v-deep .dv-scroll-ranking-board .ranking-info .rank {
      display: none;
    }

    .left1 {
      height: 94px;
      width: 100%;
      display: flex;

      .leftBC {
        background-color: #de4835;
        width: 50%;
        height: 100%;
        margin-left: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
      }
    }

    .right1BC {
      background-color: #068b62;
      width: 50%;
      height: 100%;
      margin-left: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
    }

    .right2BC {
      background-color: #0676be;
      width: 50%;
      height: 100%;
      margin-left: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
    }

    .textCenter {
      width: 30px;
      color: black;
      font-weight: 500;
      display: flex;
      align-items: center;
      justify-content: center;
      writing-mode: vertical-rl;
    }

    .line1 {
      display: flex;
      justify-content: space-around;
      font-size: 17px;
      color: #ffffff;
      margin-top: 30px;
      font-weight: 450;

      .line1-item {
        display: flex;
        align-items: center;
        width: 50%;

        .line1-title {
          background-color: #1e4082;
          width: 150px;
          padding: 20px;
          display: flex;
          text-align: center;
          align-items: center;

          img {
            width: 30px;
            height: 30px;
            margin-right: 10px;
          }
        }

        .line1-right {
          display: flex;
          align-items: center;
          flex: 1;
          justify-content: space-around;
          text-align: center;
          height: 70px;
          background-color: #102658;

          .mun {
            color: #ff6600;
            margin-top: 5px;
          }
        }
      }
    }
  }
}
</style>
